import LiveStatsList from './List';

const LiveStats = {
  LiveStatsList, 
};

export default LiveStats;